// src/features/merchantConfig/components/editors/EmailEditor.jsx
//
// Email editor — text input typed as `email` so mobile keyboards surface
// the @ key. Same commit/validate flow as UrlEditor.

import React, { useEffect, useState } from "react";
import { inputClass } from "./editorChrome";
import { validateEmail } from "../../lib/fieldValidators";

/**
 * @param {{
 *   value: string,
 *   onCommit: (next: string) => void,
 *   onInvalid?: (msg: string) => void,
 *   ariaLabel: string,
 *   hasError?: boolean,
 *   inputId?: string,
 * }} props
 */
export default function EmailEditor({
  value,
  onCommit,
  onInvalid,
  ariaLabel,
  hasError,
  inputId,
}) {
  const [draft, setDraft] = useState(value ?? "");

  useEffect(() => {
    setDraft(value ?? "");
  }, [value]);

  const commit = () => {
    if (draft === (value ?? "")) return;
    const err = validateEmail(draft);
    if (err) {
      if (onInvalid) onInvalid(err);
      return;
    }
    onCommit(draft);
  };

  return (
    <input
      id={inputId}
      type="email"
      value={draft}
      placeholder="name@example.com"
      aria-label={ariaLabel}
      aria-invalid={hasError || undefined}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          commit();
          e.currentTarget.blur();
        } else if (e.key === "Escape") {
          e.preventDefault();
          setDraft(value ?? "");
          e.currentTarget.blur();
        }
      }}
      className={inputClass({ hasError })}
    />
  );
}
